define(['moduler'], function (Moduler) {
    'use strict';
    /*
     * Add support for custom play button to videoindexer videos
     */
    return Moduler.create({
        defaults: {
            contentElement: 'iframe',
            triggerElement: '.Asset-video--poster',
            pauseTriggerElement: null,
            triggerEvent: 'click',
            hideTriggersOnEvent: true
        },

        init: function () {
            var self = this;

            self.options.targetFrame = self.el.querySelector(self.options.contentElement);
            
            let triggers = self.el.querySelectorAll(self.options.triggerElement);

            triggers.forEach(trigger => {
                trigger.addEventListener(self.options.triggerEvent, function (e) {
                    if (self.options.hideTriggersOnEvent) {
                        triggers.forEach(t => t.remove());
                    }
                    self._notifyPlayer({ play: true }, self.options.targetFrame);
                });
            });

            if (self.options.pauseTriggerElement) {
                let pauseTriggers = self.el.querySelectorAll(self.options.pauseTriggerElement);
                pauseTriggers.forEach(trigger => {
                    trigger.addEventListener(self.options.triggerEvent, function (e) {
                        self._notifyPlayer({ pause: true}, self.options.targetFrame);
                    });
                });
            }
        },

        _notifyPlayer: function (data, target) {
            let payload = {
                ...data,
                origin: "https://www.videoindexer.ai"
            };

            if ('postMessage' in window) {
                try {
                    if (target.contentWindow) {
                        target.contentWindow.postMessage(payload, payload.origin);
                    }
                } catch (error) {
                    throw error;
                }
            }
        }
    });
});